import React, { useCallback, lazy, Suspense } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useIntl } from 'react-intl';
import _ from 'lodash';

import {
    Modal
} from '@gpstrackit/gtc-react-controls';

//actions
import {
    closeQuestionConfigurationModal
} from '../../redux/slice';

import './styles.scss';

const QuestionConfiguration = (props) => {
    const dispatch = useDispatch();

    const {
        updateQuestion
    } = props;

    const open = useSelector(state => state.dynamicFormsDesignRedux.openQuestionConfiguration);
    const question = useSelector(state => state.dynamicFormsDesignRedux.question);
    const loading = useSelector(state => state.dynamicFormsDesignRedux.loading);

    const handleClose = useCallback(() => {
        dispatch(closeQuestionConfigurationModal());
    });

    const Input = lazy(() => import(`../${_.camelCase(question?.type)}/index.js`).catch(() => import(`../nullInput`)));

    return (
        <Modal
            title={question?.label}
            open={open}
            loading={loading}
            position="right"
            size="medium"
            handleClose={handleClose}
        >
            <Suspense fallback={<div>Loading...</div>}>
                <div className='design-form-question-container'>
                    <Input
                        question={question}
                        handleClose={handleClose}
                        updateQuestion={(newQuestion) => {
                            updateQuestion(newQuestion);
                            dispatch(closeQuestionConfigurationModal());
                        }}
                    />
                </div>
            </Suspense>
        </Modal>
    );
}

export default QuestionConfiguration;